// @flow

import { stringify as stringifyQuery } from 'qs';
import translate from './translate';
import prependLocale from './prependLocale';
import type { PathParams, QueryParams } from './types';

type FormatOptions = {|
  translate: boolean,
  prependLocale: boolean
|};

export default function format(
  template: string,
  pathParams: PathParams,
  queryParams: QueryParams,
  options: FormatOptions
): string {
  let result = template;

  if (options.translate) {
    result = translate(result);
  }
  if (options.prependLocale) {
    result = prependLocale(result);
  }

  result = interpolatePath(result, pathParams);
  result = appendQuery(result, queryParams);

  return result;
}

function interpolatePath(path: string, pathParams: PathParams): string {
  return Object.keys(pathParams).reduce((result, param) => {
    const value = pathParams[param];

    if (!value) {
      throw new Error(`No value supplied for path parameter :${param}`);
    }

    return result.replace(RegExp(`\\:${param}`, 'gi'), value.toString());
  }, path);
}

function appendQuery(path: string, queryParams: QueryParams): string {
  const query = stringifyQuery(queryParams, {
    arrayFormat: 'brackets',
    skipNulls: true
  });

  if (query) {
    return `${path}?${query}`;
  } else {
    return path;
  }
}
